import React from "react"
import {formatPrice} from "../utils";
import {Currency, VatAllocation} from "depoto-core";
import {useCore} from "../hooks";

type Props = {
  vatAllocations: VatAllocation[]
  currency?: Currency
}
export const VatAllocationsTable: React.FC<Props> = ({ vatAllocations, currency }) => {
  return (
    <table className="w-full table-sm text-left">
      <thead className="font-bold text-black">
      <tr>
        <th className="text-left">Sazba</th>
        <th className="text-left w-30">Základ</th>
        <th className="text-left w-30">DPH</th>
        <th className="text-right w-30">Celkem</th>
      </tr>
      </thead>
      <tbody>
      {vatAllocations.map(va => (
        <tr key={`vat-allocation-${va.vat?.percent ? va.vat.percent : va.vat}`}>
          <td>{`${va.vat?.percent ? (va.vat.percent + '%') : (va.vat !== null && va.vat !== undefined) ? va.vat : 'Celkem'}`}</td>
          <td>{`${formatPrice(va.priceWithoutVat, currency?.id)}`}</td>
          <td>{`${formatPrice(va.vatPrice, currency?.id)}`}</td>
          <td className="text-right">{`${formatPrice(va.price, currency?.id)}`}</td>
        </tr>
      ))}
      </tbody>
    </table>
  )
}
